import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import MarketingLayout from "@/components/marketing/MarketingLayout";
import MarketingPageHero from "@/components/marketing/MarketingPageHero";
import { usePageMeta } from "@/lib/usePageMeta";
import ScanDemo from "@/components/landing/ScanDemo";
import RealConversations from "@/components/landing/RealConversations";

export default function Demo() {
  usePageMeta(
    "Demo — Leadmato",
    "See a live Leadmato scan in action — from query to ranked leads across Reddit, X and LinkedIn.",
  );
  return (
    <MarketingLayout>
      <MarketingPageHero
        eyebrow="Demo"
        title="Watch a real scan run."
        subtitle="From your one-line query to ranked, save-worthy leads — no editing, no cherry-picking."
      >
        <Link
          to="/signup"
          data-testid="demo-cta-try"
          className="inline-flex items-center gap-2 bg-lm-brand-green text-[color:var(--lm-dark)] hover:bg-white text-sm font-semibold px-5 py-3 rounded-lg transition-colors"
        >
          Run your own scan
          <ArrowRight className="w-4 h-4" strokeWidth={2.2} />
        </Link>
      </MarketingPageHero>
      <ScanDemo />
      <RealConversations />
    </MarketingLayout>
  );
}
